// The browser half of the v2 canvas persistence — GET/PUT /canvas. The store
// (store.ts) owns the live widgets; this only talks to the backend: load the
// board on mount, save it on the Save button. Mirrors v1's data/layouts.ts.

import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { CanvasBoard, CanvasWidget } from "@catbento/shared";
import { apiGet, apiSend } from "../../api.js";

/** Load the caller's saved board (never-saved → empty widgets at 200). */
export function loadCanvas(): Promise<CanvasBoard> {
  return apiGet<CanvasBoard>("/canvas");
}

/** Upsert the caller's board. */
export function saveCanvas(widgets: CanvasWidget[]): Promise<CanvasBoard> {
  return apiSend<CanvasBoard>("PUT", "/canvas", { widgets });
}

/** React Query wrapper for the initial load. `staleTime: Infinity` — the board
 *  only changes when this user saves, and the store is the live source after
 *  hydrate, so we never want a background refetch clobbering unsaved edits. */
export function useCanvasBoard(): UseQueryResult<CanvasBoard, Error> {
  return useQuery({ queryKey: ["canvas"], queryFn: loadCanvas, staleTime: Infinity });
}
